import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';
import SlackBlocksBuilder from './SlackBlocksBuilder';
import SlackRawJsonField from './SlackRawJsonField';

export default function SlackConfig({ data, onChange }) {
  const fields = NODE_CONFIG_FIELDS.action_slack;
  const mode = data.messageMode || 'text';

  const visibleFields = fields.filter((f) => {
    if (f.key === 'message') return mode === 'text';
    if (f.key === 'blocks')  return mode === 'blocks';
    if (f.key === 'rawJson') return mode === 'raw';
    return true;
  });

  return (
    <div className="space-y-4">
      {visibleFields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          {field.type === 'slack_blocks' ? (
            <SlackBlocksBuilder
              value={data[field.key]}
              onChange={(v) => onChange(field.key, v)}
            />
          ) : field.type === 'slack_raw_json' ? (
            <SlackRawJsonField
              value={data[field.key]}
              onChange={(v) => onChange(field.key, v)}
            />
          ) : (
            <ConfigField
              field={field}
              value={data[field.key]}
              onChange={(v) => onChange(field.key, v)}
              allData={data}
              onChangeField={onChange}
            />
          )}
        </div>
      ))}
    </div>
  );
}
